import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4231d5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "推荐阅读", -1))
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "book-info" }
const _hoisted_5 = { class: "book-name" }
const _hoisted_6 = { class: "reads" }
const _hoisted_7 = ["onClick"]

import { ref, onMounted, watch, reactive } from 'vue';
import { searchInfo } from '@/api/request';
interface EmitsType {
  (e: 'update:show', val: boolean): void;
  (e: 'update:confirm', val): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
  show: {
    type: Boolean,
    default: false
  }
},
  emits: ["update:show", "update:confirm"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:show', val: boolean): void;
  (e: 'update:confirm', val): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props

const loginVisible = ref(false);
const keyWords = ref('');
const bookList = reactive<any>([]);




watch(
  () => props.show,
  (val) => {
    console.log(val, '触发读书弹窗');
    loginVisible.value = val;
  }
);
const select = (item) => {
  console.log(item);
  emit('update:confirm', item);
};

onMounted(() => {
  search();
});

const search = () => {
  const params = {
    type: 9,
    keyWords: keyWords.value,
    pageSize: 10,
    pageNum: 1
  };
  searchInfo.searchBook(params).then((res) => {
    bookList.values = res.body;
    console.log(bookList, res.body);
  });
};

return (_ctx: any,_cache: any) => {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: loginVisible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginVisible).value = $event)),
    class: "login-dialog",
    width: "400px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_van_search, {
          modelValue: keyWords.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyWords).value = $event)),
          "show-action": "",
          placeholder: "请输入搜索书籍关键词",
          onSearch: search
        }, {
          action: _withCtx(() => [
            _createElementVNode("div", { onClick: search }, "搜索")
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _hoisted_2,
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bookList).values, (item, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createElementVNode("span", null, _toDisplayString(index), 1),
              _createElementVNode("img", {
                src: 'https://yzims.oss-cn-shenzhen.aliyuncs.com/' + item.bookImg,
                alt: ""
              }, null, 8, _hoisted_3),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(item.bookName), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString(item.recommendNum) + "人正在阅读这本书", 1)
              ]),
              _createElementVNode("button", {
                onClick: ($event: any) => (select(item))
              }, "添加", 8, _hoisted_7)
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})